import { expertWorkspaceWebSocketEventBus } from "@expert/websocket";
import { useEffect } from "react";

import { useChatStore } from "@/sdk/agent/chat";
import { useLogger } from "@/sdk/logging/LoggerProvider";
import { userCache } from "@/shared-utils";

export interface AutopilotEventPayload {
    chatId: string;
    expertEmployeeId: string;
    durationSeconds?: number;
    startTime?: number;
    endTime?: number;
}

export const useAutopilotEventsListener = () => {
    const logger = useLogger({
        module: "useAutopilotEventsListener",
        supportTeam: "messaging",
    });

    useEffect(() => {
        return expertWorkspaceWebSocketEventBus.on("ws_chat-autopilot-event", (payload: AutopilotEventPayload) => {
            logger.info({ autopilotEventPayload: JSON.stringify(payload) }, "Autopilot event received");

            const { chatId, expertEmployeeId, startTime, durationSeconds, endTime } = payload;
            if (expertEmployeeId !== userCache.employeeId) {
                logger.info(
                    { expertEmployeeId, userCacheEmployeeId: userCache.employeeId },
                    "Ignoring autopilot event for different expert",
                );
                return;
            }

            // If no endTime, autopilot is starting/active - set the state
            if (endTime) {
                useChatStore.getState().clearChatAutopilot(chatId);
            } else if (startTime) {
                useChatStore.getState().updateChatAutopilot(chatId, { startTime, durationSeconds });
            }
        });
    }, [logger]);
};
